/**
 * Editorial "Coming Soon" placeholder used across detail-page tabs that
 * are scheduled but not yet implemented.
 */
export function ComingSoonPanel({ icon: Icon, title, blurb }) {
  return (
    <div
      className="rounded-2xl border border-dashed border-[#EDE6D8] bg-white px-6 py-10 sm:py-14 flex flex-col items-center text-center"
      data-testid="coming-soon-panel"
    >
      <div className="w-14 h-14 rounded-2xl bg-[#FCFAF6] border border-[#EDE6D8] flex items-center justify-center mb-4">
        {Icon ? (
          <Icon size={26} weight="duotone" className="text-[#0A2540]" />
        ) : null}
      </div>
      <p
        className="text-[10px] font-bold uppercase tracking-[0.25em] text-[#C9A35B] mb-2"
        style={{ fontFamily: 'JetBrains Mono, monospace' }}
      >
        Coming Soon
      </p>
      <h3
        className="text-xl font-bold text-[#1C1917] mb-2"
        style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}
      >
        {title}
      </h3>
      <p className="text-sm text-[#78716C] max-w-md">{blurb}</p>
    </div>
  );
}

export default ComingSoonPanel;
